// module.exports = require('./core/_front')
import FormWidgetMixin from './site/forms/core/FormWidgetMixin'
/*import FormWidgetMixin from './core/site/forms/core/FormWidgetMixin'*/
import _isNull from 'lodash/isNull'
import _isUndefined from 'lodash/isUndefined'

/*import 'selectric'*/

if (_isUndefined(window._)) {
  window._ = {
    isUndefined: _isUndefined,
    isNull: _isNull,
  }
}

if (!window.BackApp) {
  window.Vue = require('vue')
  let Resource = require('vue-resource')
  Vue.use(Resource)
}


Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('value')

let frontForm = (pWidgetId, elementId, pModel) => {
  if (!document.getElementById(elementId))
    return new Vue();

  return new Vue({
    el: '#' + elementId,
    mixins: [FormWidgetMixin],
    data: {
      elementId: elementId,
      model: pModel,
      widgetId: pWidgetId
    },
    watch: {
      showMessage(val, oldVal) {
        if (!val)
          return

        // <input id="{{'thx-page-' . $elementId}}" type="hidden" value="{{ page_url('thanks')}}"/>
        let url = document.querySelector('#thx-page-' + elementId)
        if (url === null)
          url = document.querySelector('#thx-page' + elementId)

        if (url === null || (url = url.getAttribute('value')) === null)
          return

        window.location = url
      }
    }
    /*
     ready(){

     let that = this;
     if (this.elementId == 'contact-form') {

     Vue.nextTick(() => {
     $('.selecter')
     .selectric({maxHeight: 250, disableOnMobile: false})
     .on('change', function (element) {
     that.model.options = $(this).val()
     });
     $('.selectric').find('.button').html('<span class="c-ab arrow_down_icon xsprite">&nbsp;</span>')


     if (this.getParameterByName('options')) {
     this.model.options = this.getParameterByName('options')
     $('.selecter').val(this.model.options).selectric('refresh')
     }//endif

     if (this.getParameterByName('subject'))
     this.model.subject = this.getParameterByName('subject')

     })

     }//endif
     }
     */
  })
}

const FrontApp = {
  frontForm,
  getAssets: (record, table, field, assets, index = null) => {
    if (record[table] === undefined || record[table][field] === undefined || record[table][field]['assets'] === undefined)
      return false;

    if(index !== null)
      return (record[table][field]['assets'][index] !== undefined && assets[record[table][field]['assets'][index]] !== undefined) ? assets[record[table][field]['assets'][index]] : false;

    let list = []
    for (let id in record[table][field]['assets'])
      if (assets[id] !== undefined)
        list.push(assets[id])

    return list
  }
}

module.exports = FrontApp



// WEBPACK FOOTER //
// ./resources/assets/js/ui/src/core/_front.js